'use client';

import Grid from "@mui/material/Grid2";
import {Box, Stack, Typography} from "@mui/material";
import LastUpdate from "@/src/components/common/pages/last-update/last-update";
import CustomDivider from "@/src/mui-custom/custom-divider/custom-divider";
import PageContentBox
    from "@/src/components/journal-site/common/page-content/mui-custom/page-content-box/page-content-box";
import ReactHtmlParser from "react-html-parser";
import SocialIcons from "@/src/components/common/pages/social-icons/social-icons";
import useSWR from "swr";
import {fetcher} from "@/src/utils/fetch-helpers";
import Loading from "@/src/components/common/loading/loading";

export default function KnowledgeBaseComponent({
                                                   initialJournalData,
                                                   initialKbData,
                                                   journalTitle,
                                                   kbSlug,
                                               }: {
    initialJournalData: any;
    initialKbData: any;
    journalTitle: string;
    kbSlug: string;
}) {

    const {
        data: journalResponse,
        isLoading: isJournalLoading
    } = useSWR(`/api/journals?path=${journalTitle}`, fetcher, {
        fallbackData: {success: true, data: [initialJournalData]},
        revalidateOnMount: false,
        revalidateOnFocus: false,
        revalidateIfStale: false,
        revalidateOnReconnect: false,
    });

    const journal = Array.isArray(journalResponse?.data) ? journalResponse.data[0] : journalResponse?.data;


    const {data: kbResponse, isLoading: isKbLoading} = useSWR(`/api/kb?slug=${kbSlug}`, fetcher, {
        fallbackData: {success: true, data: initialKbData},
        revalidateOnMount: false,
        revalidateOnFocus: false,
        revalidateIfStale: false,
        revalidateOnReconnect: false,
    });

    const kb = Array.isArray(kbResponse?.data) ? kbResponse.data[0] : kbResponse?.data;

    if (isJournalLoading || isKbLoading) {
        return (
            <Loading/>
        );
    }

    return (
        <Box sx={{width: {lg: '100%', xs: '100%'},}}>
            <Grid
                container
                spacing={2}
                py={{
                    xs: 2,
                    sm: 2,
                    md: 4
                }}
            >
                <Grid
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 2
                    }}
                >
                </Grid>
                <Grid size={{xs: 12, sm: 12, md: 8}} id={'kb-content'}>
                    {
                        kb?.title &&
                        <Typography
                            id={"kb-title"}
                            variant={'h1'}
                            fontSize={{
                                xs: '1.1rem',
                                sm: '1.2rem',
                                md: '1.75rem'
                            }}
                            marginBottom={{
                                xs: '1rem',
                                sm: '1rem',
                                md: '0rem'
                            }}
                            color={"primary"}
                        >
                            {kb?.title}
                        </Typography>
                    }
                    <Stack
                        flexDirection={{
                            xs: "column",
                            sm: "column",
                            md: "row",
                        }}
                        alignItems={{
                            xs: "center",
                            sm: "center",
                            md: "right",
                        }}
                        justifyContent={{
                            xs: "center",
                            sm: "center",
                            md: "right",
                        }}
                        mt={1}
                        gap={1.5}
                        id={'kb-updated-at'}
                        data-updated={kb.updated_at}
                    >
                        {
                            kb?.updated_at &&
                            <LastUpdate updatedAt={kb.updated_at}/>
                        }
                    </Stack>
                    <CustomDivider sx={{marginY: "1rem", marginTop: {lg: "1rem"}}}/>
                    <PageContentBox
                        px={{
                            xs: 1,
                            sm: 1,
                            md: 3
                        }}
                        py={{
                            xs: 1,
                            sm: 1,
                            md: 1
                        }}
                        mb={{
                            xs: 1,
                            sm: 1,
                            md: 3
                        }}
                        id={'kb-body'}
                    >
                        {
                            ReactHtmlParser(
                                kb.body
                            )
                        }
                    </PageContentBox>
                </Grid>
                <Grid
                    size={
                        {
                            xs: 12,
                            sm: 12,
                            md: 2
                        }
                    }
                    display={{
                        xs: 'none',
                        sm: 'none',
                        md: 'block'
                    }}
                >
                    <SocialIcons
                        url={`${journal?.journal_url}/knowledgebase/${kb?.slug}`}
                        title={kb?.title || ''}
                        direction={'row'}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}